<template>
  <div class="container-fluid articles articles--gutters articles--background articles--background-single">
    <div class="row">
      <div class="container">
        <div class="row" v-if="article">
          <div class="col-2 offset-1 d-xl-block d-none">
            <sidebar :data="article" />
          </div>
          <div class="col-md-6 col-12">
            <Article :data="article" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from "./components/Sidebar";
import Article from "./components/article/ArticleComponent";
export default {
  components: {
    sidebar, Article
  },
  data() {
    return {
      article: null
    }
  },
  async created() {
    const match = window.location.href.match(/articles\/(.*)\??/)
    const id = match && match[1]
    if (id) {
      const data = await this.$store.dispatch('getArticle', id)
      this.article = data.article
    }
    this.draftWarning();
  },
  methods: {
    /**
     * Проверяет, находится ли статья в черновике.
     * Если в строке url есть ?preview, то статья находится в черновике или на модерации.
     */
    draftWarning() {
      if (window.location.search.includes("?preview")) {
      // if (!this.article.is_on_main_page) {
        this.$noty.warning(
          `<h5>Внимание!</h5><span>Вы в режиме предпросмотра. Материал не был проверен модераторами BIMLIB.</span>`,
          {
            killer: true,
            timeout: null,
            layout: "bottomRight",
            progressBar: false
          }
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>